// config.ts

export const employeeDetails = {
  name: "Sarah Lee",
  role: "Business Development Executive",
  location: "Hyderabad",
  email: "test12345@gmail.com",
  phone: "1234567890",
  performance: "Excellent Performance!",
};

export interface KPIConfig {
  title: string;
  target?: number; // Used for Revenue/Profit
  achieved?: number; // Used for Revenue/Profit
  percentageChange?: number; // Used for Revenue/Profit
  value?: number; // Used for Gauge Widgets (Deals, Accounts, Contacts)
  outOf?: number; // Used for Gauge Widgets
  items?: {
    label: string;
    value: number;
  }[];
  color: string;
}

// Configuration for the top-row metrics
export const gaugeMetrics: KPIConfig[] = [
  {
    title: "Deals",
    value: 120,
    outOf: 300,
    color: "#2DD4BF", // Teal/Cyan color from the image
    items: [
      { label: "Deals Created", value: 120 },
      { label: "Deals Converted", value: 112 },
      { label: "Deals Lost", value: 15 },
    ],
  },
  {
    title: "Accounts",
    value: 120,
    outOf: 300,
    color: "#4F46E5", // Indigo/Blue color
    items: [
      { label: "Accounts Created", value: 120 },
      { label: "Accounts Converted", value: 112 },
      { label: "Accounts Lost", value: 15 },
    ],
  },
  {
    title: "Contacts",
    value: 120,
    outOf: 300,
    color: "#F97316", // Orange color
    items: [
      { label: "Contacts Created", value: 120 },
      { label: "Contacts Converted", value: 112 },
      { label: "Contacts Lost", value: 15 },
    ],
  },
];

// Configuration for the bottom-row metrics
export const revenueProfitMetrics: KPIConfig[] = [
  {
    title: "Revenue",
    target: 10000000,
    achieved: 8700000,
    percentageChange: 4.6,
    color: "#10B981", // Green for achievement bar
  },
  {
    title: "Profit",
    target: 10000000,
    achieved: 8700000,
    percentageChange: 4.6,
    color: "#A855F7", // Purple for achievement bar
  },
];